import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import { get } from '@rails/request.js'

export default class extends Controller {
  openModal(event) {
    event.preventDefault()

    get(event.currentTarget.href, { responseKind: 'turbo-stream' }).then(
      ({ response: { ok, redirected, url } }) => {
        if (redirected) {
          // Handle the "redirect_to" redirects from the controller
          Turbo.visit(url)
        } else if (ok) {
          this.dispatch('modal-content-loaded')
        }
      }
    )
  }
}
